import { StyleSheet, } from "@react-pdf/renderer";

const fonts = {
    courier: "Courier",
    courierBold: "Courier-Bold",
    courierOblique: "Courier-Oblique",
    helvetica: "Helvetica",
    helveticaBold: "Helvetica-Bold",
    helveticaOblique: "Helvetica-Oblique",
    times: "Times-Roman",
    timesBold: "Times-Bold",
    timesItalic: "Times-Italic",
};
export const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 45,
        fontSize: 10,
        fontFamily: fonts.helvetica,
      },
    pageNumber: {
        position: "absolute",
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
        color: "grey",
      },
      view: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "505px",
      },
      row: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        paddingTop: 4,
        width: "505px",
      },
      col_header: {
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      table: {
        marginTop: 15,
        display: 'table',
        width: '100%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000000',
      },
      tableRow: {
        flexDirection: 'row',
      },
      tableCell: {
        padding: 4,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000000',
      },
      pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center'
      }
})